import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { FaUserAlt } from 'react-icons/fa';

const WelcomePage = () => {
  const navigate = useNavigate();
  const [visibleLetters, setVisibleLetters] = useState(0);
  const [showCards, setShowCards] = useState(false);

  const title = 'MissionMap LC';

  const letterColors = [
    'text-red-500','text-orange-500','text-yellow-500',
    'text-green-500','text-teal-500','text-blue-500',
    'text-indigo-500','text-purple-500','text-pink-500'
  ];

  useEffect(() => {
    if (visibleLetters < title.length) {
      const timer = setTimeout(() => {
        setVisibleLetters((prev) => prev + 1);
      }, 200);
      return () => clearTimeout(timer);
    } else {
      setTimeout(() => setShowCards(true), 500);
    }
  }, [visibleLetters]);

  // 🔐 SECRET KEY COMBO → COMPANY LOGIN
  useEffect(() => {
    const handleKey = (e) => {
      if (e.ctrlKey && e.shiftKey && e.key === 'L') {
        navigate('/company-login'); // 👉 Company login here
      }
    };

    window.addEventListener('keydown', handleKey);
    return () => window.removeEventListener('keydown', handleKey);
  }, []);

  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-gradient-to-br from-yellow-100 to-pink-200 p-6">

      {/* 🔐 DOUBLE CLICK → CEO LOGIN */}
      <h1 
        onDoubleClick={() => navigate('/login')} // 👉 CEO login
        className="text-5xl md:text-6xl font-extrabold mb-12 flex space-x-1 cursor-pointer"
      >
        {title.split('').map((char, index) => (
          <span
            key={index}
            className={`transition-opacity duration-300 ${
              index < visibleLetters ? 'opacity-100' : 'opacity-0'
            } ${letterColors[index % letterColors.length]}`}
          >
            {char}
          </span>
        ))}
      </h1>

      {/* 👤 ONLY USER LOGIN */}
      {showCards && (
        <div className="w-full max-w-md">
          <div className="bg-white p-8 rounded-2xl shadow-lg text-center">
            
            <FaUserAlt className="text-6xl text-pink-500 mb-4 mx-auto" />

            <h2 className="text-2xl font-bold mb-2">User Login</h2>
            <p className="text-gray-600 mb-6">
              Login to view your profile and data
            </p>

            <button
              onClick={() => navigate('/user-login')}
              className="bg-pink-500 hover:bg-pink-600 text-white px-6 py-2 rounded-lg"
            >
              Go to User Login
            </button>

          </div>
        </div>
      )}

    </div>
  );
};

export default WelcomePage;